import { ref } from "@vue/composition-api";
import { Page } from "@scrile/api-provider/dist/api/PageProvider";
import providers from "@/lib/api";

export const useStaticPages = () => {
  const pages = ref<Page[]>([]);

  const getPages = async () => {
    pages.value = await providers.PageProvider.find();
  };

  return {
    pages,
    getPages,
  };
};
